import React from 'react';
import type { Store as StoreType } from '../../../../services/authService';
import { useStoreDetailsManualEntries } from '../hooks/useStoreDetailsManualEntries';
import StoreDetailsLoadingButton from './StoreDetailsLoadingButton';
import StoreDetailsManualEntriesTab from './StoreDetailsManualEntriesTab';

type StoreDetailsManualEntriesTabContainerProps = {
    store: StoreType | null;
    todayDate: string;
};

const StoreDetailsManualEntriesTabContainer: React.FC<StoreDetailsManualEntriesTabContainerProps> = ({
    store,
    todayDate,
}) => {
    const manualEntriesState = useStoreDetailsManualEntries({
        store,
        todayDate,
    });

    return (
        <StoreDetailsManualEntriesTab
            canShowManualLottoSales={manualEntriesState.canShowManualLottoSales}
            canShowManualPayout={manualEntriesState.canShowManualPayout}
            manualLottoPayload={manualEntriesState.manualLottoPayload}
            manualPayoutPayload={manualEntriesState.manualPayoutPayload}
            manualLottoSubmitting={manualEntriesState.manualLottoSubmitting}
            manualPayoutSubmitting={manualEntriesState.manualPayoutSubmitting}
            isManualLottoFormValid={manualEntriesState.isManualLottoFormValid}
            isManualPayoutFormValid={manualEntriesState.isManualPayoutFormValid}
            todayDate={todayDate}
            onManualLottoPayloadChange={manualEntriesState.setManualLottoPayload}
            onManualPayoutPayloadChange={manualEntriesState.setManualPayoutPayload}
            onSubmitManualLottoSales={manualEntriesState.handleSubmitManualLottoSales}
            onSubmitManualPayout={manualEntriesState.handleSubmitManualPayout}
            loadingButton={(
                <StoreDetailsLoadingButton variant="contained" sx={{ backgroundColor: '#2C6CA0', fontWeight: 600 }}>
                    Submit
                </StoreDetailsLoadingButton>
            )}
        />
    );
};

export default React.memo(StoreDetailsManualEntriesTabContainer);
